<div class="card smaller configuration-panel-card k-mt-5">
  <div class="card-header">Bild</div>
  <div class="card-body">Grundfarbe:</div>
</div>
